(function () {

  function initShippingPolicy() {

    const wrapper = document.querySelector(
      '[data-sh24-policy-shipping]'
    );

    const dataElement = document.getElementById(
      'sh24-policy-shipping-rates'
    );

    if (!wrapper || !dataElement) {
      return;
    }


    let rates;

    try {

      rates = JSON.parse(
        dataElement.textContent
      );

    } catch (error) {

      console.error(
        'SH24: Versanddaten konnten nicht geladen werden.',
        error
      );

      return;

    }


    const formatPrice = (value) => {

      return Number(value).toLocaleString(
        'de-DE',
        {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ) + ' €';

    };


    const formatWeight = (value) => {

      if (value >= 1000) {

        return (
          value / 1000
        ).toLocaleString('de-DE') + ' t';

      }

      return value.toLocaleString('de-DE') + ' kg';

    };


    const parcelFrom = wrapper.querySelector(
      '[data-policy-parcel-from]'
    );

    const freightFrom = wrapper.querySelector(
      '[data-policy-freight-from]'
    );

    const directFrom = wrapper.querySelector(
      '[data-policy-direct-from]'
    );


    if (parcelFrom) {
      parcelFrom.textContent =
        formatPrice(rates.parcelFrom);
    }

    if (freightFrom) {
      freightFrom.textContent =
        formatPrice(rates.freightFrom);
    }

    if (directFrom) {
      directFrom.textContent =
        formatPrice(rates.directFrom);
    }


    const detail = wrapper.querySelector(
      '[data-shipping-policy-detail]'
    );

    const detailTitle = wrapper.querySelector(
      '[data-shipping-policy-detail-title]'
    );

    const detailContent = wrapper.querySelector(
      '[data-shipping-policy-detail-content]'
    );


    function showParcel() {

      detailTitle.innerHTML = `
        <h3>GLS Paketversand</h3>
        <p>
          Für Zubehör und Kleinteile bis 40 kg
        </p>
      `;


      detailContent.innerHTML = `

        <div class="sh24-policy-shipping__parcel-grid">

          ${rates.parcel.map(rate => `

            <div class="sh24-policy-shipping__parcel-price">

              <span>
                bis ${rate.k.toLocaleString('de-DE')} kg
              </span>

              <strong>
                ${formatPrice(rate.p)}
              </strong>

            </div>

          `).join('')}

        </div>

      `;

    }


    function showFreight() {

      detailTitle.innerHTML = `
        <h3>Speditionslieferung</h3>
        <p>
          Module, Speicher und Komplettsysteme
          mit telefonischer Avisierung.
        </p>
      `;


      detailContent.innerHTML = `

        <table class="sh24-policy-shipping-table">

          <thead>

            <tr>
              <th>Gewicht</th>
              <th>Versandkosten</th>
            </tr>

          </thead>

          <tbody>

            ${rates.freight.map(rate => `

              <tr>

                <td>
                  ${formatWeight(rate.l)}
                  bis
                  ${formatWeight(rate.h)}
                </td>

                <td>
                  ${formatPrice(rate.p)}
                </td>

              </tr>

            `).join('')}

          </tbody>

        </table>

      `;

    }


    function showDirect() {

      detailTitle.innerHTML = `
        <h3>Direktlieferung per LKW</h3>
        <p>
          Ohne Umladung direkt zu Ihnen.
        </p>
      `;


      detailContent.innerHTML = `

        <table class="sh24-policy-shipping-table">

          <thead>

            <tr>
              <th>Gewicht</th>
              <th>Lademeter</th>
              <th>Versandkosten</th>
            </tr>

          </thead>

          <tbody>

            ${rates.direct.map(rate => `

              <tr>

                <td>
                  ${formatWeight(rate.l)}
                  bis
                  ${formatWeight(rate.h)}
                </td>

                <td>
                  ${rate.m} LDM
                </td>

                <td>
                  ${formatPrice(rate.p)}
                </td>

              </tr>

            `).join('')}

          </tbody>

        </table>

      `;

    }


    function showPickup() {

      detailTitle.innerHTML = `
        <h3>Kostenlose Abholung</h3>
        <p>
          Direkt an unserem Standort in Düsseldorf.
        </p>
      `;


      detailContent.innerHTML = `

        <p>
          <strong>solago GmbH</strong><br>
          Reisholzer Bahnstraße 39<br>
          40599 Düsseldorf
        </p>

        <p>
          Die Abholung ist für alle Produkte kostenlos.
          Den Link zur Terminbuchung erhalten Sie
          nach Ihrer Bestellung per E-Mail.
        </p>

      `;

    }


    wrapper
      .querySelectorAll('[data-shipping-policy-open]')
      .forEach(button => {

        button.addEventListener('click', function () {

          const type =
            this.dataset.shippingPolicyOpen;


          if (type === 'parcel') {
            showParcel();
          }

          if (type === 'freight') {
            showFreight();
          }

          if (type === 'direct') {
            showDirect();
          }

          if (type === 'pickup') {
            showPickup();
          }


          detail.hidden = false;


          detail.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });

        });

      });


    const closeButton = wrapper.querySelector(
      '[data-shipping-policy-close]'
    );


    if (closeButton) {

      closeButton.addEventListener(
        'click',
        function () {

          detail.hidden = true;

        }
      );

    }

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initShippingPolicy
    );

  } else {

    initShippingPolicy();

  }

})();